/**
 * This is the property of FRBNY and cannot be shared or disclosed without consent and strictly prohibited.
 * 
 * Story: FR-TSM-003 (View Tour Calendar)
 * Generated by: AI-DLC Workflow
 * 
 * Main application entry point for TRS Public UI.
 * 
 * Security Features:
 * - Clears tour-related session storage on application startup
 * - Detects and handles page reloads (F5, browser refresh)
 * - Prevents bookmarking by clearing session state on reload
 * - Always redirects to privacy agreement screen first
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './assets/styles/main.css';

// Clear tour-related session storage on application startup
// This ensures users always start with privacy agreement
// and prevents bookmarked URLs from working
sessionStorage.removeItem('tourPrivacyAccepted');

// Detect page reload/refresh and clear session state
// This prevents users from refreshing on any page and staying there
window.addEventListener('beforeunload', () => {
    // Mark that the page is being unloaded
    // On next load, router will detect this is a fresh page load
    sessionStorage.removeItem('trsSessionInitialized');
    sessionStorage.removeItem('trsNavigationAllowed');
    console.log('Page unload detected - session state will be reset');
});

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

app.mount('#app');
